import { parseAsString, useQueryState } from 'nuqs';
import { Navigate } from 'react-router';

import { RoutePathType } from '~/routing/enums';
import { useRouting } from '~/routing/useRouting';

import {
  DOCUMENTS_PANEL_KEY,
  WORKFLOW_SETTINGS_SEARCH_PARAM,
} from '../settings/workflowSettingsConstants';
import { TEMPLATE_SEARCH_PARAM } from './useDocumentTemplateModal';

/**
 * Templates moved from their own builder section into a modal over the canvas.
 * Keeps links to the retired `/documents` route working: one naming a template
 * reopens it, a bare one lands on the templates panel.
 */
export const WorkflowDocumentsRedirect = () => {
  const { params } = useRouting();
  const { workflowId = '' } = params;
  const [templateId] = useQueryState(TEMPLATE_SEARCH_PARAM, parseAsString);
  const workflowPath = `${RoutePathType.WorkflowCLMEvolutionWorkflowsDetail.replace(
    ':workflowId',
    workflowId,
  )}/workflow`;
  const search = templateId
    ? `${TEMPLATE_SEARCH_PARAM}=${encodeURIComponent(templateId)}`
    : `${WORKFLOW_SETTINGS_SEARCH_PARAM}=${DOCUMENTS_PANEL_KEY}`;

  return <Navigate replace to={`${workflowPath}?${search}`} />;
};
